<template>
  <div class="gm606-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="4">
        报警状态：
        <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmText }}</span>
      </el-col>
      <el-col tag="span" :span="4">
        运行状态：
        <span :class="runState | runClass">{{ runState | runText }}</span>
      </el-col>
    </el-row>
    <div class="common-border mt-15">
      <el-row type="flex" justify="center" align="middle" class="pump-status common-border2">
        <el-col tag="span" :span="6">
          <span class="iconfont icon-pump"></span>
          泵安装状态：{{ pumpStatus.install | pumpInstallText }}
        </el-col>
        <el-col tag="span" :span="6">
          <span class="iconfont icon-pump"></span>
          泵运行状态：{{ pumpStatus.run | pumpRunText }}
        </el-col>
        <el-col tag="span" :span="6" v-if="!isEmpty(absoluteHumidity)">
          <span class="iconfont icon-humidity2"></span>
          绝对湿度：{{ absoluteHumidity }}g/m³
        </el-col>
        <el-col tag="span" :span="6">
          <span class="iconfont icon-humidity2"></span>
          相对湿度：{{ humidity }}%
        </el-col>
        <el-col tag="span" :span="6" v-if="!isEmpty(atmosphericPressure)">
          <span class="iconfont icon-dqyq"></span>
          大气压强：{{ atmosphericPressure }}kPa
        </el-col>
        <el-col tag="span" :span="6">
          <span class="iconfont icon-temperature2"></span>
          温度：{{ temperature }}℃
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tools } from '../utils';
import { isEmpty } from '@/utils/is';

export default {
  props: {
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    pumpStatus: {
      type: Object,
      default: () => ({
        install: 0,
        run: 0
      })
    },
    humidity: {
      type: Number,
      required: true
    },
    temperature: {
      type: Number,
      requires: true
    },
    absoluteHumidity: {
      type: Number,
      requires: true
    },
    atmosphericPressure: {
      type: Number,
      requires: true
    }
  },
  filters: tools,
  methods: {
    isEmpty
  }
};
</script>

<style lang="scss">
.gm606-status-bar {
  .col-btn {
    color: #49c7c3;
    cursor: pointer;
    &:hover {
      color: #3da4a2;
      border-color: transparent;
      background-color: transparent;
    }
  }

  .pump-status {
    height: 50px;
  }
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;

    &:first-of-type {
      padding-left: 0;
    }
  }
}
</style>
